import "./index.html";
import "./index.scss";

require("offline-plugin/runtime").install();
